import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Standard height/appearance for every single-line form control in the app
 * (inputs, selects, comboboxes, date pickers). Keep at 40px (h-10) so controls
 * line up with each other and with default buttons.
 */
export const FIELD_CLASS =
  "flex h-10 w-full items-center rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

/** Same look as FIELD_CLASS but for multi-line textareas. */
export const FIELD_TEXTAREA_CLASS =
  "flex min-h-20 w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

/** Row wrapper that makes a checkbox/radio line as tall as a field. */
export const FIELD_CHECKBOX_ROW_CLASS = "flex h-10 items-center gap-2 text-sm";
